import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { MIN_DESKTOP_BREAKPOINT } from './constants/_breakpoints';

const Wrapper = styled.div`
  display: none;

  @media only screen and (min-width: ${MIN_DESKTOP_BREAKPOINT}) {
    display: block;
  }
`;

const DesktopOnly = ({ children }) => <Wrapper>{children}</Wrapper>;

DesktopOnly.propTypes = {
  children: PropTypes.element.isRequired,
};

export default DesktopOnly;
